/* Basanti Premium Theme */
(() => {
  'use strict';

  const qs = (selector, scope = document) => scope.querySelector(selector);
  const qsa = (selector, scope = document) => Array.from(scope.querySelectorAll(selector));
  const escapeHTML = (value = '') => String(value).replace(/[&<>'"]/g, char => ({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[char]));

  function formatMoney(cents) {
    const value = Number(cents || 0);
    const format = window.Basanti?.moneyFormat || 'AED {{ amount }}';
    const token = format.match(/\{\{\s*(amount(?:_no_decimals|_with_comma_separator|_no_decimals_with_comma_separator)?)\s*\}\}/);
    if (!token) return `${(value / 100).toFixed(2)} ${window.Basanti?.currency || ''}`.trim();
    let output;
    switch (token[1]) {
      case 'amount_no_decimals': output = Math.round(value / 100).toLocaleString('en-AE'); break;
      case 'amount_with_comma_separator': output = (value / 100).toLocaleString('de-DE', {minimumFractionDigits: 2, maximumFractionDigits: 2}); break;
      case 'amount_no_decimals_with_comma_separator': output = Math.round(value / 100).toLocaleString('de-DE'); break;
      default: output = (value / 100).toLocaleString('en-AE', {minimumFractionDigits: 2, maximumFractionDigits: 2});
    }
    return format.replace(token[0], output).replace(/<[^>]*>/g, '').trim();
  }

  function showToast(message, type = '') {
    let toast = qs('#toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.id = 'toast';
      toast.className = 'toast';
      toast.setAttribute('role', 'status');
      document.body.appendChild(toast);
    }
    toast.textContent = message;
    toast.className = `toast ${type}`;
    requestAnimationFrame(() => toast.classList.add('show'));
    clearTimeout(toast._timer);
    toast._timer = setTimeout(() => toast.classList.remove('show'), 3000);
  }

  const Cart = {
    data: null,
    async fetch() {
      const response = await fetch('/cart.js', {headers: {'Accept': 'application/json'}});
      if (!response.ok) throw new Error('Could not load your bag.');
      this.data = await response.json();
      return this.data;
    },
    async add(item, openDrawer = true) {
      const items = Array.isArray(item) ? item : [item];
      const response = await fetch('/cart/add.js', {
        method: 'POST', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'}, body: JSON.stringify({items})
      });
      const data = await response.json().catch(() => ({}));
      if (!response.ok) throw new Error(data.description || data.message || 'This item could not be added.');
      await this.fetch();
      CartDrawer.render();
      if (openDrawer) CartDrawer.open();
      return data;
    },
    async change(key, quantity) {
      const response = await fetch('/cart/change.js', {
        method: 'POST', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'}, body: JSON.stringify({id: key, quantity: Number(quantity)})
      });
      const data = await response.json().catch(() => ({}));
      if (!response.ok) throw new Error(data.description || 'Your bag could not be updated.');
      this.data = data;
      CartDrawer.render();
      renderCartPage();
      return data;
    },
    remove(key) { return this.change(key, 0); }
  };

  const CartDrawer = {
    drawer: null,
    overlay: null,
    init() {
      this.drawer = qs('#cartDrawer');
      this.overlay = qs('#cartOverlay');
      qs('#cartTrigger')?.addEventListener('click', () => this.toggle());
      qs('#cartClose')?.addEventListener('click', () => this.close());
      this.overlay?.addEventListener('click', () => this.close());
      document.addEventListener('keydown', event => { if (event.key === 'Escape') this.close(); });
      Cart.fetch().then(() => this.render()).catch(() => {});
    },
    open() {
      this.drawer?.classList.add('open');
      this.drawer?.setAttribute('aria-hidden', 'false');
      this.overlay?.classList.add('open');
      document.body.classList.add('drawer-open');
    },
    close() {
      this.drawer?.classList.remove('open');
      this.drawer?.setAttribute('aria-hidden', 'true');
      this.overlay?.classList.remove('open');
      document.body.classList.remove('drawer-open');
    },
    toggle() { this.drawer?.classList.contains('open') ? this.close() : Cart.fetch().then(() => { this.render(); this.open(); }); },
    render() {
      const cart = Cart.data;
      if (!cart) return;
      qsa('.cart-count').forEach(badge => {
        badge.textContent = cart.item_count;
        badge.hidden = cart.item_count === 0;
      });
      const body = qs('#cartItems');
      if (!body) return;
      if (!cart.items.length) {
        body.innerHTML = `<div class="cart-empty"><p>Your bag is empty.</p><a href="${escapeHTML(window.Basanti?.routes?.allProducts || '/collections/all')}" class="btn btn-primary btn-sm">Start shopping</a></div>`;
      } else {
        body.innerHTML = cart.items.map(item => {
          const discounted = item.original_line_price > item.final_line_price;
          return `<article class="cart-item">
            <a href="${escapeHTML(item.url)}"><img class="cart-item-img" src="${escapeHTML(item.image || '')}" alt="${escapeHTML(item.product_title)}"></a>
            <div class="cart-item-info">
              <a class="cart-item-title" href="${escapeHTML(item.url)}">${escapeHTML(item.product_title)}</a>
              <div class="cart-item-variant">${item.variant_title && item.variant_title !== 'Default Title' ? escapeHTML(item.variant_title) : ''}</div>
              <div class="cart-item-prices"><span class="cart-item-price">${escapeHTML(formatMoney(item.final_line_price))}</span>${discounted ? `<span class="cart-item-old">${escapeHTML(formatMoney(item.original_line_price))}</span>` : ''}</div>
              <div class="cart-item-controls">
                <div class="qty-box"><button type="button" data-cart-change="${escapeHTML(item.key)}" data-quantity="${Math.max(0, item.quantity - 1)}" aria-label="Decrease quantity">−</button><input type="number" value="${item.quantity}" min="0" data-cart-input="${escapeHTML(item.key)}" aria-label="Quantity"><button type="button" data-cart-change="${escapeHTML(item.key)}" data-quantity="${item.quantity + 1}" aria-label="Increase quantity">+</button></div>
                <button type="button" class="cart-item-remove" data-cart-remove="${escapeHTML(item.key)}">Remove</button>
              </div>
            </div>
          </article>`;
        }).join('');
      }
      const subtotal = qs('#cartSubtotal');
      if (subtotal) subtotal.textContent = formatMoney(cart.total_price);
      const savings = cart.items.reduce((total, item) => total + Math.max(0, item.original_line_price - item.final_line_price), 0);
      const savingsElement = qs('#cartSavings');
      if (savingsElement) {
        savingsElement.hidden = savings <= 0;
        savingsElement.textContent = savings > 0 ? `You saved ${formatMoney(savings)}` : '';
      }
    }
  };

  document.addEventListener('click', event => {
    const changeButton = event.target.closest('[data-cart-change]');
    if (changeButton) Cart.change(changeButton.dataset.cartChange, changeButton.dataset.quantity).catch(error => showToast(error.message, 'error'));
    const removeButton = event.target.closest('[data-cart-remove]');
    if (removeButton) Cart.remove(removeButton.dataset.cartRemove).catch(error => showToast(error.message, 'error'));
  });
  document.addEventListener('change', event => {
    if (event.target.matches('[data-cart-input]')) Cart.change(event.target.dataset.cartInput, Math.max(0, Number(event.target.value || 0))).catch(error => showToast(error.message, 'error'));
  });

  function initMobileMenu() {
    const trigger = qs('#mobileMenuBtn');
    const closeButton = qs('#mobileMenuClose');
    const menu = qs('#mobileMenu');
    const overlay = qs('#mobileOverlay');
    if (!menu || !trigger) return;
    const open = () => { menu.classList.add('open'); menu.setAttribute('aria-hidden', 'false'); overlay?.classList.add('open'); trigger.setAttribute('aria-expanded', 'true'); document.body.classList.add('drawer-open'); };
    const close = () => { menu.classList.remove('open'); menu.setAttribute('aria-hidden', 'true'); overlay?.classList.remove('open'); trigger.setAttribute('aria-expanded', 'false'); document.body.classList.remove('drawer-open'); };
    trigger.addEventListener('click', open);
    closeButton?.addEventListener('click', close);
    overlay?.addEventListener('click', close);
    qsa('.mobile-submenu-toggle', menu).forEach(button => button.addEventListener('click', () => {
      const submenu = button.closest('.mobile-nav-item')?.querySelector('.mobile-submenu');
      const expanded = button.getAttribute('aria-expanded') === 'true';
      button.setAttribute('aria-expanded', String(!expanded));
      button.textContent = expanded ? '+' : '−';
      submenu?.classList.toggle('open', !expanded);
    }));
  }

  function initSearch() {
    const drawer = qs('#searchDrawer');
    const trigger = qs('#searchTrigger');
    const close = qs('#searchClose');
    if (!drawer || !trigger) return;
    const open = () => { drawer.classList.add('open'); drawer.setAttribute('aria-hidden', 'false'); setTimeout(() => qs('#searchInput')?.focus(), 150); };
    const hide = () => { drawer.classList.remove('open'); drawer.setAttribute('aria-hidden', 'true'); };
    trigger.addEventListener('click', open); close?.addEventListener('click', hide);
    document.addEventListener('keydown', event => { if (event.key === 'Escape') hide(); });
  }

  function initReveal() {
    const elements = qsa('.reveal,.reveal-left,.reveal-right');
    if (!('IntersectionObserver' in window)) { elements.forEach(el => el.classList.add('visible')); return; }
    const observer = new IntersectionObserver(entries => entries.forEach(entry => { if (entry.isIntersecting) { entry.target.classList.add('visible'); observer.unobserve(entry.target); } }), {threshold: .08, rootMargin: '0px 0px -20px'});
    elements.forEach(el => observer.observe(el));
  }

  function initHeader() {
    const header = qs('.site-header');
    if (!header || header.classList.contains('site-header-static')) return;
    const update = () => header.classList.toggle('scrolled', window.scrollY > 30);
    window.addEventListener('scroll', update, {passive: true}); update();
  }

  function initTicker() {
    const ticker = qs('.announcement-ticker');
    if (!ticker || ticker.dataset.ready === 'true') return;
    const items = qsa('.ann-item', ticker);
    if (!items.length) return;
    items.forEach(item => ticker.appendChild(item.cloneNode(true)));
    ticker.dataset.ready = 'true';
  }

  function initProductPage() {
    if (!qs('.product-layout')) return;
    const mainImage = qs('#galleryMain');
    const thumbnails = qsa('.gallery-thumb');
    let currentIndex = Math.max(0, thumbnails.findIndex(item => item.classList.contains('active')));
    const selectImage = index => {
      if (!thumbnails.length || !mainImage || mainImage.tagName !== 'IMG') return;
      currentIndex = (index + thumbnails.length) % thumbnails.length;
      thumbnails.forEach((thumb, i) => thumb.classList.toggle('active', i === currentIndex));
      mainImage.src = thumbnails[currentIndex].dataset.full;
    };
    thumbnails.forEach((thumb, index) => thumb.addEventListener('click', () => selectImage(index)));
    qs('#galleryPrev')?.addEventListener('click', () => selectImage(currentIndex - 1));
    qs('#galleryNext')?.addEventListener('click', () => selectImage(currentIndex + 1));

    const variants = window.__basantiVariants || [];
    const variantInput = qs('#variantId');
    const addButton = qs('#addToCart');
    const buyButton = qs('#buyNow');
    const mobileButton = qs('#mobileAddToCart');

    const selectedOptions = () => {
      const output = [];
      qsa('[data-opt-pos].active').forEach(button => { output[Number(button.dataset.optPos) - 1] = button.dataset.value; });
      return output;
    };
    const findVariant = () => variants.find(variant => variant.options.every((option, index) => selectedOptions()[index] === option));

    function updateVariant(variant) {
      if (!variant) return;
      if (variantInput) variantInput.value = variant.id;
      const price = qs('#productPrice'); if (price) price.textContent = formatMoney(variant.price);
      const mobilePrice = qs('#mobileProductPrice'); if (mobilePrice) mobilePrice.textContent = formatMoney(variant.price);
      const was = qs('#productWas');
      const discount = qs('#productDiscount');
      const save = qs('#productSave');
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        const percent = Math.round((1 - variant.price / variant.compare_at_price) * 100);
        if (was) { was.hidden = false; was.textContent = formatMoney(variant.compare_at_price); }
        if (discount) { discount.hidden = false; discount.textContent = `${percent}% off`; }
        if (save) { save.hidden = false; save.textContent = `You save ${formatMoney(variant.compare_at_price - variant.price)}`; }
      } else {
        if (was) was.hidden = true; if (discount) discount.hidden = true; if (save) save.hidden = true;
      }
      const available = Boolean(variant.available);
      [addButton, mobileButton].forEach(button => { if (!button) return; button.disabled = !available; button.textContent = available ? 'Add to bag' : 'Sold out'; });
      if (buyButton) buyButton.hidden = !available;
      const status = qs('#productAvailability'); if (status) { status.classList.toggle('out', !available); status.innerHTML = available ? '<b>●</b> In stock' : 'Sold out'; }
      const mobileStatus = qs('#mobileProductAvailability'); if (mobileStatus) mobileStatus.textContent = available ? 'In stock' : 'Sold out';
      const soldoutBanner = qs('#soldoutBanner'); if (soldoutBanner) soldoutBanner.hidden = available;
      const sku = qs('#productSku'); if (sku) sku.textContent = variant.sku || '';
      if (variant.featured_image?.src && mainImage?.tagName === 'IMG') mainImage.src = variant.featured_image.src;
      const url = new URL(window.location.href); url.searchParams.set('variant', variant.id); history.replaceState({}, '', url);
    }

    qsa('.size-opt,.color-opt').forEach(button => button.addEventListener('click', () => {
      if (button.disabled) return;
      qsa(`[data-opt-pos="${button.dataset.optPos}"]`).forEach(item => item.classList.remove('active'));
      button.classList.add('active');
      const label = qs(`#${button.dataset.selectedLabel}`); if (label) label.textContent = button.dataset.value;
      updateVariant(findVariant());
    }));
    const initial = variants.find(variant => String(variant.id) === String(window.__basantiCurrentVariant)) || variants.find(variant => variant.available) || variants[0];
    if (initial) updateVariant(initial);

    const addCurrent = async (openDrawer = true) => {
      const variantId = Number(variantInput?.value);
      const quantity = Math.max(1, Number(qs('#productQty')?.value || 1));
      if (!variantId) throw new Error('Please choose an available option.');
      return Cart.add({id: variantId, quantity}, openDrawer);
    };
    addButton?.addEventListener('click', async event => {
      event.preventDefault();
      addButton.disabled = true; addButton.textContent = 'Adding…';
      try { await addCurrent(true); showToast('Added to your bag.', 'success'); }
      catch (error) { showToast(error.message, 'error'); }
      finally { const variant = variants.find(item => String(item.id) === String(variantInput?.value)); addButton.disabled = !variant?.available; addButton.textContent = variant?.available ? 'Add to bag' : 'Sold out'; }
    });
    mobileButton?.addEventListener('click', () => addButton?.click());
    buyButton?.addEventListener('click', async () => { buyButton.disabled = true; buyButton.textContent = 'Opening checkout…'; try { await addCurrent(false); window.location.href = '/checkout'; } catch (error) { showToast(error.message, 'error'); buyButton.disabled = false; buyButton.textContent = 'Buy now'; } });
    qs('#qtyMinus')?.addEventListener('click', () => { const input = qs('#productQty'); if (input) input.value = Math.max(1, Number(input.value) - 1); });
    qs('#qtyPlus')?.addEventListener('click', () => { const input = qs('#productQty'); if (input) input.value = Math.min(20, Number(input.value) + 1); });
  }

  function initQuickAdd() {
    document.addEventListener('click', async event => {
      const button = event.target.closest('.atc-btn[data-variant]');
      if (!button) return;
      event.preventDefault();
      const original = button.textContent;
      button.disabled = true; button.textContent = 'Adding…';
      try { await Cart.add({id: Number(button.dataset.variant), quantity: 1}); showToast('Added to your bag.', 'success'); }
      catch (error) { showToast(error.message, 'error'); }
      finally { button.disabled = false; button.textContent = original; }
    });
  }

  function initWishlist() {
    let saved = [];
    try { saved = JSON.parse(localStorage.getItem('basantiWishlist') || '[]'); } catch (_) {}
    const refresh = () => qsa('[data-product].wishlist-btn,[data-product].btn-wishlist-big').forEach(button => { const active = saved.includes(button.dataset.product); button.classList.toggle('active', active); button.textContent = active ? '♥' : '♡'; });
    refresh();
    document.addEventListener('click', event => {
      const button = event.target.closest('[data-product].wishlist-btn,[data-product].btn-wishlist-big');
      if (!button) return;
      const handle = button.dataset.product;
      saved = saved.includes(handle) ? saved.filter(item => item !== handle) : [...saved, handle];
      localStorage.setItem('basantiWishlist', JSON.stringify(saved)); refresh();
      showToast(saved.includes(handle) ? 'Saved for later.' : 'Removed from saved items.');
    });
  }

  function initCollection() {
    qsa('.sort-select').forEach(select => select.addEventListener('change', () => { const url = new URL(window.location.href); url.searchParams.set('sort_by', select.value); window.location.href = url.toString(); }));
    qsa('.grid-btn').forEach(button => button.addEventListener('click', () => {
      qsa('.grid-btn').forEach(item => item.classList.remove('active')); button.classList.add('active');
      const grid = qs('.collection-results .products-grid'); if (!grid) return;
      grid.classList.remove('cols-3', 'cols-4'); grid.classList.add(`cols-${button.dataset.cols}`);
      localStorage.setItem('basantiGridColumns', button.dataset.cols);
    }));
    const savedCols = localStorage.getItem('basantiGridColumns'); if (savedCols) qs(`.grid-btn[data-cols="${savedCols}"]`)?.click();

    const panel = qs('#filterPanel'); const overlay = qs('#filterOverlay'); const trigger = qs('#mobileFilterTrigger');
    const open = () => { panel?.classList.add('open'); overlay?.classList.add('open'); trigger?.setAttribute('aria-expanded', 'true'); document.body.classList.add('drawer-open'); };
    const close = () => { panel?.classList.remove('open'); overlay?.classList.remove('open'); trigger?.setAttribute('aria-expanded', 'false'); document.body.classList.remove('drawer-open'); };
    trigger?.addEventListener('click', open); qs('#mobileFilterClose')?.addEventListener('click', close); overlay?.addEventListener('click', close);
  }

  function renderCartPage() {
    const container = qs('#cartTableBody');
    if (!container || !Cart.data) return;
    const cart = Cart.data;
    if (!cart.items.length) {
      container.innerHTML = '<tr><td colspan="5" class="cart-page-empty">Your bag is empty.</td></tr>';
    } else {
      container.innerHTML = cart.items.map(item => `<tr><td><img class="cart-table-img" src="${escapeHTML(item.image || '')}" alt="${escapeHTML(item.product_title)}"></td><td><a class="cart-table-title" href="${escapeHTML(item.url)}">${escapeHTML(item.product_title)}</a><div class="cart-table-variant">${item.variant_title !== 'Default Title' ? escapeHTML(item.variant_title) : ''}</div></td><td>${escapeHTML(formatMoney(item.final_price))}</td><td><div class="qty-box"><button type="button" data-cart-change="${escapeHTML(item.key)}" data-quantity="${Math.max(0,item.quantity-1)}">−</button><input type="number" min="0" value="${item.quantity}" data-cart-input="${escapeHTML(item.key)}"><button type="button" data-cart-change="${escapeHTML(item.key)}" data-quantity="${item.quantity+1}">+</button></div></td><td><strong>${escapeHTML(formatMoney(item.final_line_price))}</strong><button type="button" class="cart-table-remove" data-cart-remove="${escapeHTML(item.key)}">Remove</button></td></tr>`).join('');
    }
    const subtotal = qs('#summarySubtotal'); if (subtotal) subtotal.textContent = formatMoney(cart.total_price);
    const total = qs('#summaryTotal'); if (total) total.textContent = formatMoney(cart.total_price);
  }

  function initCartPage() {
    const form = qs('#CartForm');
    if (!form) return;
    qsa('[data-cart-step]', form).forEach(button => button.addEventListener('click', () => {
      const input = button.parentElement?.querySelector('[data-cart-quantity]');
      if (!input) return;
      const next = Math.max(0, Number(input.value || 0) + (button.dataset.cartStep === 'plus' ? 1 : -1));
      input.value = next;
      const updateButton = qs('#CartUpdateButton');
      if (form.requestSubmit && updateButton) form.requestSubmit(updateButton); else form.submit();
    }));
  }
  function initBackToTop() { const button = qs('#backTop'); if (!button) return; const update = () => button.classList.toggle('visible', window.scrollY > 500); window.addEventListener('scroll', update, {passive: true}); button.addEventListener('click', () => window.scrollTo({top: 0, behavior: 'smooth'})); }
  function initNewsletter() { if (new URLSearchParams(window.location.search).get('customer_posted') === 'true') showToast('Welcome to the Basanti community.', 'success'); }

  document.addEventListener('DOMContentLoaded', () => {
    CartDrawer.init(); initMobileMenu(); initSearch(); initReveal(); initHeader(); initTicker(); initProductPage(); initQuickAdd(); initWishlist(); initCollection(); initCartPage(); initBackToTop(); initNewsletter();
  });

  window.Cart = Cart;
  window.CartDrawer = CartDrawer;
  window.showToast = showToast;
  window.formatMoney = formatMoney;
})();
